var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutOfOffice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.594 15.417a.834.834 0 0 0-.834.833v.417c0 .23-.187.416-.417.416H8.756a.417.417 0 0 1-.417-.416V3.333c0-.23.187-.416.417-.416h4.587c.23 0 .417.186.417.416v.834a.834.834 0 0 0 1.667 0V2.083a.834.834 0 0 0-.833-.833H8.339V.417A.417.417 0 0 0 7.832.01L.327 1.677A.417.417 0 0 0 0 2.083v15.834c0 .195.136.365.327.407l7.505 1.667a.417.417 0 0 0 .507-.408v-.834h6.255c.46 0 .833-.373.833-.833v-1.667a.834.834 0 0 0-.833-.832zm-8.34-5a1.25 1.25 0 1 1-2.5-.001 1.25 1.25 0 0 1 2.5 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.629 9.723-4.066-2.708a.834.834 0 0 0-1.296.693v1.459h-3.44a1.25 1.25 0 1 0 0 2.5h3.44v1.458a.833.833 0 0 0 1.296.693l4.066-2.708a.833.833 0 0 0 0-1.387z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOfOffice);
export default __webpack_public_path__ + "static/media/out-of-office.2fc3c1d98a57549361fd4894420b9153.svg";
export { ForwardRef as ReactComponent };